 <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M6 2.75A2.25 2.25 0 0 0 3.75 5v14A2.25 2.25 0 0 0 6 21.25h12A2.25 2.25 0 0 0 20.25 19V7.5a.75.75 0 0 0-.22-.53l-4.5-4.5a.75.75 0 0 0-.53-.22zM14.25 4.56L18.44 8.75h-3.44a.75.75 0 0 1-.75-.75zM6 4.25h6.75V8a2.25 2.25 0 0 0 2.25 2.25h3.75V19A.75.75 0 0 1 18 19.75H6a.75.75 0 0 1-.75-.75V5A.75.75 0 0 1 6 4.25m1.5 8.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75m0 3a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75" />
      </svg>